import React, { useEffect, useState } from 'react';
import { Contest } from '../../../global';
import axiosHelper from '../../../helpers/axiosHelper';
import styles from './DropDown.module.scss';
import useSWR from 'swr';

interface Props {
  value?: Contest | null;
  onChange: (contest: Contest | null) => void;
}

const ContestSelect: React.FC<Props> = ({ value, onChange }) => {
  const { data, error, isLoading } = useSWR('all', axiosHelper.contestsFetcher);
  const [contests, setContests] = useState<Contest[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (data) {
      const filteredContests = data.filter((contest: Contest) => 
        !contest.isClosed && new Date(contest.endUploadDate) > new Date()
      );
      setContests(filteredContests);
    }
  }, [data]);

  const isSelected = (option: Contest) => {
    return value && value.id === option.id ? styles.selected : '';
  };

  const selectContest = (contest: Contest | null) => {
    onChange(contest);
    setOpen(false);
  };

  const selectMyWall = () => {
    onChange(null);
    setOpen(false);
  };

  return (
    <div className={`${styles.dropdown_wrapper_year}`}>
      <div className={`${styles.dropdown} ${open ? styles.open : ''}`}>
        <div className={`${styles.dropdown__toggle}`} onClick={() => setOpen(!open)}>
          <span className={`${styles.dropdown__label} w-75`}>
            {value ? value.name : 'My Wall'}
          </span>
          <div className={`${styles.arrow}`}></div>
        </div>
        <div className={`${styles.dropdown__optionslist}`}>
          <div 
            className={`${styles.dropdown__option} ${value === null ? styles.selected : ''}`} 
            onClick={selectMyWall}
          >
            My Wall
          </div>
          <div className={`${styles.dropdown__spacer}`}>&nbsp;</div>
          {contests.map((option, index) => (
            <div key={index} className={`${styles.dropdown__option} ${isSelected(option)}`} data-value={option.name} onClick={() => selectContest(option)}>
              {option.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContestSelect;
